import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebase/config.js';
import { Link } from 'react-router-dom';
import confirmed from '../../assets/Hub/confirm.webp';
import React, { useState, useRef, useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

// Lista de países con sus códigos y códigos de país para las banderas
const paisesConCodigo = [
  { codigo: '+93', pais: 'Afganistán', codigoPais: 'af' },
  { codigo: '+27', pais: 'África del Sur', codigoPais: 'za' },
  { codigo: '+355', pais: 'Albania', codigoPais: 'al' },
  { codigo: '+49', pais: 'Alemania', codigoPais: 'de' },
  { codigo: '+244', pais: 'Angola', codigoPais: 'ao' },
  { codigo: '+966', pais: 'Arabia Saudita', codigoPais: 'sa' },
  { codigo: '+213', pais: 'Argelia', codigoPais: 'dz' },
  { codigo: '+54', pais: 'Argentina', codigoPais: 'ar' },
  { codigo: '+374', pais: 'Armenia', codigoPais: 'am' },
  { codigo: '+61', pais: 'Australia', codigoPais: 'au' },
  { codigo: '+43', pais: 'Austria', codigoPais: 'at' },
  { codigo: '+994', pais: 'Azerbaiyán', codigoPais: 'az' },
  { codigo: '+1', pais: 'Bahamas', codigoPais: 'bs' },
  { codigo: '+880', pais: 'Bangladesh', codigoPais: 'bd' },
  { codigo: '+32', pais: 'Bélgica', codigoPais: 'be' },
  { codigo: '+501', pais: 'Belice', codigoPais: 'bz' },
  { codigo: '+229', pais: 'Benin', codigoPais: 'bj' },
  { codigo: '+375', pais: 'Bielorrusia', codigoPais: 'by' },
  { codigo: '+591', pais: 'Bolivia', codigoPais: 'bo' },
  { codigo: '+387', pais: 'Bosnia y Herzegovina', codigoPais: 'ba' },
  { codigo: '+267', pais: 'Botswana', codigoPais: 'bw' },
  { codigo: '+55', pais: 'Brasil', codigoPais: 'br' },
  { codigo: '+673', pais: 'Brunei', codigoPais: 'bn' },
  { codigo: '+359', pais: 'Bulgaria', codigoPais: 'bg' },
  { codigo: '+226', pais: 'Burkina Faso', codigoPais: 'bf' },
  { codigo: '+855', pais: 'Camboya', codigoPais: 'kh' },
  { codigo: '+237', pais: 'Camerún', codigoPais: 'cm' },
  { codigo: '+1', pais: 'Canadá', codigoPais: 'ca' },
  { codigo: '+56', pais: 'Chile', codigoPais: 'cl' },
  { codigo: '+86', pais: 'China', codigoPais: 'cn' },
  { codigo: '+357', pais: 'Chipre', codigoPais: 'cy' },
  { codigo: '+57', pais: 'Colombia', codigoPais: 'co' },
  { codigo: '+82', pais: 'Corea del Sur', codigoPais: 'kr' },
  { codigo: '+506', pais: 'Costa Rica', codigoPais: 'cr' },
  { codigo: '+225', pais: 'Costa de Marfil', codigoPais: 'ci' },
  { codigo: '+385', pais: 'Croacia', codigoPais: 'hr' },
  { codigo: '+53', pais: 'Cuba', codigoPais: 'cu' },
  { codigo: '+45', pais: 'Dinamarca', codigoPais: 'dk' },
  { codigo: '+1', pais: 'República Dominicana', codigoPais: 'do' },
  { codigo: '+593', pais: 'Ecuador', codigoPais: 'ec' },
  { codigo: '+20', pais: 'Egipto', codigoPais: 'eg' },
  { codigo: '+503', pais: 'El Salvador', codigoPais: 'sv' },
  { codigo: '+971', pais: 'Emiratos Árabes Unidos', codigoPais: 'ae' },
  { codigo: '+34', pais: 'España', codigoPais: 'es' },
  { codigo: '+1', pais: 'Estados Unidos', codigoPais: 'us' },
  { codigo: '+372', pais: 'Estonia', codigoPais: 'ee' },
  { codigo: '+251', pais: 'Etiopía', codigoPais: 'et' },
  { codigo: '+63', pais: 'Filipinas', codigoPais: 'ph' },
  { codigo: '+358', pais: 'Finlandia', codigoPais: 'fi' },
  { codigo: '+679', pais: 'Fiyi', codigoPais: 'fj' },
  { codigo: '+33', pais: 'Francia', codigoPais: 'fr' },
  { codigo: '+241', pais: 'Gabón', codigoPais: 'ga' },
  { codigo: '+220', pais: 'Gambia', codigoPais: 'gm' },
  { codigo: '+995', pais: 'Georgia', codigoPais: 'ge' },
  { codigo: '+233', pais: 'Ghana', codigoPais: 'gh' },
  { codigo: '+30', pais: 'Grecia', codigoPais: 'gr' },
  { codigo: '+502', pais: 'Guatemala', codigoPais: 'gt' },
  { codigo: '+224', pais: 'Guinea', codigoPais: 'gn' },
  { codigo: '+509', pais: 'Haití', codigoPais: 'ht' },
  { codigo: '+31', pais: 'Holanda', codigoPais: 'nl' },
  { codigo: '+504', pais: 'Honduras', codigoPais: 'hn' },
  { codigo: '+36', pais: 'Hungría', codigoPais: 'hu' },
  { codigo: '+91', pais: 'India', codigoPais: 'in' },
  { codigo: '+62', pais: 'Indonesia', codigoPais: 'id' },
  { codigo: '+964', pais: 'Irak', codigoPais: 'iq' },
  { codigo: '+98', pais: 'Irán', codigoPais: 'ir' },
  { codigo: '+353', pais: 'Irlanda', codigoPais: 'ie' },
  { codigo: '+354', pais: 'Islandia', codigoPais: 'is' },
  { codigo: '+972', pais: 'Israel', codigoPais: 'il' },
  { codigo: '+39', pais: 'Italia', codigoPais: 'it' },
  { codigo: '+1', pais: 'Jamaica', codigoPais: 'jm' },
  { codigo: '+81', pais: 'Japón', codigoPais: 'jp' },
  { codigo: '+962', pais: 'Jordania', codigoPais: 'jo' },
  { codigo: '+254', pais: 'Kenia', codigoPais: 'ke' },
  { codigo: '+996', pais: 'Kirguistán', codigoPais: 'kg' },
  { codigo: '+965', pais: 'Kuwait', codigoPais: 'kw' },
  { codigo: '+856', pais: 'Laos', codigoPais: 'la' },
  { codigo: '+371', pais: 'Letonia', codigoPais: 'lv' },
  { codigo: '+961', pais: 'Líbano', codigoPais: 'lb' },
  { codigo: '+231', pais: 'Liberia', codigoPais: 'lr' },
  { codigo: '+370', pais: 'Lituania', codigoPais: 'lt' },
  { codigo: '+352', pais: 'Luxemburgo', codigoPais: 'lu' },
  { codigo: '+389', pais: 'Macedonia del Norte', codigoPais: 'mk' },
  { codigo: '+261', pais: 'Madagascar', codigoPais: 'mg' },
  { codigo: '+60', pais: 'Malasia', codigoPais: 'my' },
  { codigo: '+265', pais: 'Malaui', codigoPais: 'mw' },
  { codigo: '+960', pais: 'Maldivas', codigoPais: 'mv' },
  { codigo: '+356', pais: 'Malta', codigoPais: 'mt' },
  { codigo: '+212', pais: 'Marruecos', codigoPais: 'ma' },
  { codigo: '+230', pais: 'Mauricio', codigoPais: 'mu' },
  { codigo: '+52', pais: 'México', codigoPais: 'mx' },
  { codigo: '+373', pais: 'Moldavia', codigoPais: 'md' },
  { codigo: '+377', pais: 'Mónaco', codigoPais: 'mc' },
  { codigo: '+976', pais: 'Mongolia', codigoPais: 'mn' },
  { codigo: '+382', pais: 'Montenegro', codigoPais: 'me' },
  { codigo: '+258', pais: 'Mozambique', codigoPais: 'mz' },
  { codigo: '+95', pais: 'Myanmar (Birmania)', codigoPais: 'mm' },
  { codigo: '+264', pais: 'Namibia', codigoPais: 'na' },
  { codigo: '+977', pais: 'Nepal', codigoPais: 'np' },
  { codigo: '+505', pais: 'Nicaragua', codigoPais: 'ni' },
  { codigo: '+227', pais: 'Níger', codigoPais: 'ne' },
  { codigo: '+234', pais: 'Nigeria', codigoPais: 'ng' },
  { codigo: '+47', pais: 'Noruega', codigoPais: 'no' },
  { codigo: '+64', pais: 'Nueva Zelanda', codigoPais: 'nz' },
  { codigo: '+968', pais: 'Omán', codigoPais: 'om' },
  { codigo: '+92', pais: 'Pakistán', codigoPais: 'pk' },
  { codigo: '+507', pais: 'Panamá', codigoPais: 'pa' },
  { codigo: '+675', pais: 'Papúa Nueva Guinea', codigoPais: 'pg' },
  { codigo: '+595', pais: 'Paraguay', codigoPais: 'py' },
  { codigo: '+51', pais: 'Perú', codigoPais: 'pe' },
  { codigo: '+48', pais: 'Polonia', codigoPais: 'pl' },
  { codigo: '+351', pais: 'Portugal', codigoPais: 'pt' },
  { codigo: '+1', pais: 'Puerto Rico', codigoPais: 'pr' },
  { codigo: '+974', pais: 'Qatar', codigoPais: 'qa' },
  { codigo: '+44', pais: 'Reino Unido', codigoPais: 'gb' },
  { codigo: '+420', pais: 'República Checa', codigoPais: 'cz' },
  { codigo: '+243', pais: 'República Democrática del Congo', codigoPais: 'cd' },
  { codigo: '+40', pais: 'Rumania', codigoPais: 'ro' },
  { codigo: '+7', pais: 'Rusia', codigoPais: 'ru' },
  { codigo: '+250', pais: 'Ruanda', codigoPais: 'rw' },
  { codigo: '+221', pais: 'Senegal', codigoPais: 'sn' },
  { codigo: '+381', pais: 'Serbia', codigoPais: 'rs' },
  { codigo: '+65', pais: 'Singapur', codigoPais: 'sg' },
  { codigo: '+963', pais: 'Siria', codigoPais: 'sy' },
  { codigo: '+252', pais: 'Somalia', codigoPais: 'so' },
  { codigo: '+94', pais: 'Sri Lanka', codigoPais: 'lk' },
  { codigo: '+27', pais: 'Sudáfrica', codigoPais: 'za' },
  { codigo: '+249', pais: 'Sudán', codigoPais: 'sd' },
  { codigo: '+46', pais: 'Suecia', codigoPais: 'se' },
  { codigo: '+41', pais: 'Suiza', codigoPais: 'ch' },
  { codigo: '+66', pais: 'Tailandia', codigoPais: 'th' },
  { codigo: '+886', pais: 'Taiwán', codigoPais: 'tw' },
  { codigo: '+255', pais: 'Tanzania', codigoPais: 'tz' },
  { codigo: '+992', pais: 'Tayikistán', codigoPais: 'tj' },
  { codigo: '+670', pais: 'Timor Oriental', codigoPais: 'tl' },
  { codigo: '+228', pais: 'Togo', codigoPais: 'tg' },
  { codigo: '+676', pais: 'Tonga', codigoPais: 'to' },
  { codigo: '+1', pais: 'Trinidad y Tobago', codigoPais: 'tt' },
  { codigo: '+216', pais: 'Túnez', codigoPais: 'tn' },
  { codigo: '+993', pais: 'Turkmenistán', codigoPais: 'tm' },
  { codigo: '+90', pais: 'Turquía', codigoPais: 'tr' },
  { codigo: '+380', pais: 'Ucrania', codigoPais: 'ua' },
  { codigo: '+256', pais: 'Uganda', codigoPais: 'ug' },
  { codigo: '+598', pais: 'Uruguay', codigoPais: 'uy' },
  { codigo: '+998', pais: 'Uzbekistán', codigoPais: 'uz' },
  { codigo: '+58', pais: 'Venezuela', codigoPais: 've' },
  { codigo: '+84', pais: 'Vietnam', codigoPais: 'vn' },
  { codigo: '+967', pais: 'Yemen', codigoPais: 'ye' },
  { codigo: '+260', pais: 'Zambia', codigoPais: 'zm' },
  { codigo: '+263', pais: 'Zimbabue', codigoPais: 'zw' },
];

// Componente personalizado para el selector de país
const SelectorPais = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectorRef = useRef(null);
  const selectedPais = paisesConCodigo.find((p) => p.codigo === value) || paisesConCodigo[1]; // Default a México

  // Crear un div para el portal si no existe
  useEffect(() => {
    // Solo crear el div si no existe ya
    if (!document.getElementById('country-dropdown-portal')) {
      const portalDiv = document.createElement('div');
      portalDiv.id = 'country-dropdown-portal';
      document.body.appendChild(portalDiv);
    }

    return () => {
      // Limpiar al desmontar
      const portalDiv = document.getElementById('country-dropdown-portal');
      if (portalDiv) {
        document.body.removeChild(portalDiv);
      }
    };
  }, []);

  // Cerrar el dropdown al hacer clic en cualquier parte
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e) => {
      if (selectorRef.current && !selectorRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    // Usar setTimeout para evitar que el clic que abre también cierre
    setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 0);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  // Renderizar el dropdown
  const renderDropdown = () => {
    if (!isOpen || !selectorRef.current) return null;

    const selectorRect = selectorRef.current.getBoundingClientRect();
    const portalDiv = document.getElementById('country-dropdown-portal');

    if (!portalDiv) return null;

    return createPortal(
      <div
        className="bg-white shadow-lg border border-gray-200 rounded overflow-y-auto"
        style={{
          position: 'fixed',
          width: Math.max(selectorRect.width * 2.5, 200),
          maxHeight: '240px',
          top: `${selectorRect.bottom}px`,
          left: `${selectorRect.left}px`,
          zIndex: 9999999,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        }}
      >
        {paisesConCodigo.map((pais) => (
          <div
            key={`${pais.codigo}-${pais.pais}`}
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center"
            onClick={() => {
              onChange(pais.codigo);
              setIsOpen(false);
            }}
          >
            <img
              src={`https://flagcdn.com/w20/${pais.codigoPais}.png`}
              alt={pais.pais}
              className="w-5 h-4 mr-2"
            />
            <span className="mr-2">{pais.codigo}</span>
            <span className="text-xs text-gray-500 truncate">{pais.pais}</span>
          </div>
        ))}
      </div>,
      portalDiv
    );
  };

  return (
    <div className="relative flex-shrink-0 w-[90px] sm:w-[100px] md:w-[120px]">
      <div
        ref={selectorRef}
        className="w-full h-[38px] flex items-center border-b border-[#D1D5DB] bg-transparent text-[#666666] cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="mr-1 flex-shrink-0">
          <img
            src={`https://flagcdn.com/w20/${selectedPais.codigoPais}.png`}
            alt={selectedPais.pais}
            className="w-4 h-3 sm:w-5 sm:h-4"
          />
        </span>
        <span className="text-xs md:text-sm whitespace-nowrap font-raleway tracking-[0.5px] md:tracking-[1px]">
          {selectedPais.codigo}
        </span>
        <svg
          className="w-3 h-3 md:w-4 md:h-4 text-[#666666] ml-auto flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {renderDropdown()}
    </div>
  );
};

function ContactoServicios({ isModal = false, onClose, showTemaSelector = true }) {
  const { t } = useTranslation();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [nombre, setNombre] = useState('');
  const [apellido, setApellido] = useState('');
  const [correo, setCorreo] = useState('');
  const [codigoPais, setCodigoPais] = useState('+51');
  const [numeroTelefono, setNumeroTelefono] = useState('');
  const [temaSeleccionado, setTemaSeleccionado] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [camposFaltantes, setCamposFaltantes] = useState([]);

  const temasDeInteres = useMemo(() => {
    const items = t('services.common.accordion', { returnObjects: true });
    return Array.isArray(items) ? items.map((it) => it.title) : [];
  }, [t]);

  const FIELD_KEYS = {
    name: 'name',
    surname: 'surname',
    email: 'email',
    phone: 'phone',
    topic: 'topic',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setCamposFaltantes([]);

    // Validar campos obligatorios
    const camposFaltantesArray = [];
    if (!nombre) camposFaltantesArray.push(FIELD_KEYS.name);
    if (!apellido) camposFaltantesArray.push(FIELD_KEYS.surname);
    if (!correo) camposFaltantesArray.push(FIELD_KEYS.email);
    if (!numeroTelefono) camposFaltantesArray.push(FIELD_KEYS.phone);

    if (showTemaSelector && !temaSeleccionado) {
      camposFaltantesArray.push(FIELD_KEYS.topic);
    }

    // Si hay campos faltantes, mostrar error y detener el envío
    if (camposFaltantesArray.length > 0) {
      setCamposFaltantes(camposFaltantesArray);
      setError(t('contact.errors.requiredFields'));
      return;
    }

    setLoading(true);

    try {
      // Formato completo del teléfono: código país + número
      const telefonoCompleto = `${codigoPais} ${numeroTelefono}`;

      // Obtener el objeto del país seleccionado para guardar su nombre
      const paisSeleccionado = paisesConCodigo.find((p) => p.codigo === codigoPais) || {
        pais: 'Desconocido',
      };

      const contactData = {
        nombre,
        apellido,
        correo,
        telefono: telefonoCompleto,
        // Datos desglosados del teléfono
        telefonoData: {
          codigoPais: codigoPais,
          numero: numeroTelefono,
          pais: paisSeleccionado.pais,
        },
        fechaRegistro: new Date(),
      };

      if (showTemaSelector && temaSeleccionado) {
        contactData.temaInteres = temaSeleccionado;
      }

      // Guardar datos en Firestore
      const collectionName = showTemaSelector ? 'contactoservicios' : 'contactosoporte';
      const docRef = await addDoc(collection(db, collectionName), contactData);
      if (process.env.NODE_ENV === 'development') {
        console.log(`Contacto guardado en ${collectionName} con ID:`, docRef.id);
      }

      // Mostrar confirmación y reiniciar formulario
      setShowConfirmation(true);

      setTimeout(() => {
        setShowConfirmation(false);
        setNombre('');
        setApellido('');
        setCorreo('');
        setCodigoPais('+51');
        setNumeroTelefono('');
        setTemaSeleccionado('');
        if (isModal && onClose) {
          onClose();
        }
      }, 3000);
    } catch (error) {
      console.error('Error al procesar el formulario:', error);
      setError(t('contact.errors.submitFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-full w-full px-4 sm:px-6">
      <div className="w-full max-w-[500px]">
        {showConfirmation ? (
          <div className="text-center py-4 md:py-8">
            <div className="flex justify-center mb-4 md:mb-6">
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center">
                <img src={confirmed} alt="confirmed" className="w-12 h-12 md:w-16 md:h-16" />
              </div>
            </div>
            <p className="mb-4 md:mb-6 text-[#141e55] text-xs sm:text-sm font-raleway tracking-wider leading-relaxed px-2">
              {t('contact.success')}
            </p>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center w-full">
            <h1 className="text-center mb-2 md:mb-4 text-[#152b5a] font-playfair text-[24px] sm:text-[32px] md:text-[40px] tracking-[3px] sm:tracking-[6px] md:tracking-[9px] leading-[32px] sm:leading-[42px] md:leading-[52px]">
              {t('contact.title')}
            </h1>
            <p className="text-center mb-4 md:mb-8 text-[#152b5a] font-raleway text-[12px] sm:text-[14px] md:text-[18px] tracking-[2px] sm:tracking-[3px] md:tracking-[4px] leading-[16px] sm:leading-[18px] md:leading-[23px]">
              {t('contact.subtitle')}
            </p>

            {error && (
              <div className="w-full mb-6 px-4 py-3 bg-red-50 border border-red-200 rounded-md">
                <p className="text-red-600 text-xs sm:text-sm font-raleway font-medium">{error}</p>
                {camposFaltantes.length > 0 && (
                  <ul className="list-disc ml-5 mt-1 text-red-600 text-xs sm:text-sm font-raleway">
                    {camposFaltantes.map((key, index) => {
                      const labels = {
                        [FIELD_KEYS.name]: t('contact.fields.nameLabel'),
                        [FIELD_KEYS.surname]: t('contact.fields.surnameLabel'),
                        [FIELD_KEYS.email]: t('contact.fields.emailLabel'),
                        [FIELD_KEYS.phone]: t('contact.fields.phoneLabel'),
                        [FIELD_KEYS.topic]: t('contact.fields.topicLabel'),
                      };
                      return <li key={index}>{labels[key] || key}</li>;
                    })}
                  </ul>
                )}
              </div>
            )}

            <form onSubmit={handleSubmit} className="w-full space-y-4 md:space-y-6">
              <div className="relative">
                <input
                  type="text"
                  placeholder={t('contact.fields.namePlaceholder')}
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  className={`w-full h-[38px] border-b ${
                    camposFaltantes.includes(FIELD_KEYS.name)
                      ? 'border-red-500 focus:border-red-500'
                      : 'border-[#D1D5DB] focus:border-[#152b5a]'
                  } focus:outline-none bg-transparent text-[#666666] text-xs md:text-sm font-raleway tracking-[1px] leading-[16px] md:leading-[20px]`}
                  required
                />
              </div>

              <div className="relative">
                <input
                  type="text"
                  placeholder={t('contact.fields.surnamePlaceholder')}
                  value={apellido}
                  onChange={(e) => setApellido(e.target.value)}
                  className={`w-full h-[38px] border-b ${
                    camposFaltantes.includes(FIELD_KEYS.surname)
                      ? 'border-red-500 focus:border-red-500'
                      : 'border-[#D1D5DB] focus:border-[#152b5a]'
                  } focus:outline-none bg-transparent text-[#666666] text-xs md:text-sm font-raleway tracking-[1px] leading-[16px] md:leading-[20px]`}
                  required
                />
              </div>

              <div className="relative">
                <input
                  type="email"
                  placeholder={t('contact.fields.emailPlaceholder')}
                  value={correo}
                  onChange={(e) => setCorreo(e.target.value)}
                  className={`w-full h-[38px] border-b ${
                    camposFaltantes.includes(FIELD_KEYS.email)
                      ? 'border-red-500 focus:border-red-500'
                      : 'border-[#D1D5DB] focus:border-[#152b5a]'
                  } focus:outline-none bg-transparent text-[#666666] text-xs md:text-sm font-raleway tracking-[1px] leading-[16px] md:leading-[20px]`}
                  required
                />
              </div>

              <div className="flex items-center space-x-2 sm:space-x-3">
                <SelectorPais value={codigoPais} onChange={setCodigoPais} />

                <div className="relative flex-grow">
                  <input
                    type="tel"
                    placeholder={t('contact.fields.phonePlaceholder')}
                    value={numeroTelefono}
                    onChange={(e) => setNumeroTelefono(e.target.value)}
                    className={`w-full h-[38px] border-b ${
                      camposFaltantes.includes(FIELD_KEYS.phone)
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-[#D1D5DB] focus:border-[#152b5a]'
                    } focus:outline-none bg-transparent text-[#666666] text-xs md:text-sm font-raleway tracking-[1px] leading-[16px] md:leading-[20px]`}
                    required
                  />
                </div>
              </div>

              {showTemaSelector && (
                <div className="relative">
                  <select
                    value={temaSeleccionado}
                    onChange={(e) => setTemaSeleccionado(e.target.value)}
                    className={`w-full h-[38px] border-b ${
                      camposFaltantes.includes(FIELD_KEYS.topic)
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-[#D1D5DB] focus:border-[#152b5a]'
                    } focus:outline-none bg-transparent text-[#666666] text-xs md:text-sm font-raleway tracking-[1px] leading-[16px] md:leading-[20px] appearance-none cursor-pointer`}
                  >
                    <option value="">{t('contact.selectTopicPrompt')}</option>
                    {temasDeInteres.map((tema) => (
                      <option key={tema} value={tema}>
                        {tema}
                      </option>
                    ))}
                  </select>
                  <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
                    <svg
                      className="w-3 h-3 md:w-4 md:h-4 text-[#666666]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              )}

              <div className="mt-2 md:mt-4">
                <p className="mt-2 md:mt-4 text-[#31373d] text-[10px] xs:text-xs font-raleway tracking-[0.5px] md:tracking-[1px] leading-[14px] md:leading-[16px]">
                  {t('contact.legal.accept')}{' '}
                  <Link
                    to="/condiciones-de-uso"
                    className="underline cursor-pointer hover:text-[#152b5a] transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('contact.legal.terms')}
                  </Link>{' '}
                  {t('contact.legal.and')}{' '}
                  <Link
                    to="/privacidad"
                    className="underline cursor-pointer hover:text-[#152b5a] transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('contact.legal.privacy')}
                  </Link>
                  .
                </p>
              </div>

              <div className="flex justify-center mt-4 md:mt-8">
                <button
                  type="submit"
                  disabled={loading}
                  className={`w-[140px] md:w-[169px] h-[40px] md:h-[47px] px-6 md:px-8 py-2 bg-[#152b5a] text-white text-xs md:text-sm font-raleway tracking-[1.5px] md:tracking-[2px] leading-[20px] md:leading-[24px] transition-all ${
                    loading ? 'opacity-70 cursor-wait' : 'hover:bg-[#1f3f85]'
                  }`}
                >
                  {loading ? t('contact.buttons.sending') : t('contact.buttons.send')}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default ContactoServicios;
